import { IFetchStatus } from 'types/rest/IFetchStatus';
import { IDiscountsData } from '../../../ui-toolkit/discounts/types/IDiscounts';

export interface IDiscountsState {
  discounts: { [orderId: string]: IDiscountsData[] };
  discountsFetchStatus: { [orderId: string]: IFetchStatus };
  discountsError: { [orderId: string]: Error | null };
  updateDiscountsFetchStatus: { [orderId: string]: IFetchStatus };
  updateDiscountsError: { [orderId: string]: Error | null };
}

export const discountsInitialState: IDiscountsState = {
  discounts: {},
  discountsFetchStatus: {},
  discountsError: {},
  updateDiscountsFetchStatus: {},
  updateDiscountsError: {},
};
